import { DriverLicense } from '../driver/types';
import { Deliveries } from '../freight/types';

/* eslint-disable camelcase */
export enum TablesTypes {
  GET_DASHBOARD_ADMIN = '@Fretapp/GET_DASHBOARD_ADMIN',
  GET_DASHBOARD = '@Fretapp/GET_DASHBOARD',
  GET_VEHICLE_TYPES = '@Fretapp/GET_VEHICLE_TYPES',
  GET_ENTERPRISES = '@Fretapp/GET_ENTERPRISES',
  GET_DISTRIBUTORS = '@Fretapp/GET_DISTRIBUTORS',
  GET_DISTRIBUTOR = '@Fretapp/GET_DISTRIBUTOR',
  GET_DRIVERS = '@Fretapp/GET_DRIVERS',
  GET_DELIVERIES = '@Fretapp/GET_DELIVERIES',
  SET_DELIVERY = '@Fretapp/SET_DELIVERY',
  GET_VEHICLES = '@Fretapp/GET_VEHICLES',
  GET_USERS = '@Fretapp/GET_USERS',
  GET_ADMINS = '@Fretapp/GET_ADMINS',
  GET_RECEIPTS = '@Fretapp/GET_RECEIPTS',
  GET_COMPANIES = '@Fretapp/GET_COMPANIES',
  GET_DISTRIBUTORS_USERS = '@Fretapp/GET_DISTRIBUTORS_USERS',
  GET_FREIGHTS = '@Fretapp/GET_FREIGHTS',
  GET_REPROCESS = '@Fretapp/GET_REPROCESS',
  GET_AVAILABLE_CARTS = '@Fretapp/GET_AVAILABLE_CARTS',
}

export interface DashboardAdmin {
  chargeNumber: number;
  company: string;
  price: number;
  registerDate: string;
  loadingDate: string;
  vehicleType: string;
}

export interface Dashboard {
  id: number;
  price: number;
  vehicle_type_id: string;
  created_at: string;
  delivery_limit_date: string;
}

export interface Freights {
  page: number;
  totalRecords: number;
  rows: {
    loadNumbers: string;
    plate?: string;
    freightId: string;
    freightCost: number;
    totalKilometers: number;
    numberOfHelpers: number;
    deliveryLimitDate: string;
    freightStatus: string;
    vehicleTypePrice: number;
    createdAt: string;
    updatedAt: string;
    vehicleTypeVehicleTypeId: string;
    distributorsdistributorId: string;
    driverDriverId?: string;
    adminAdminId?: string;
    totalWeight: number;
    pickUpDate?: string;
    acceptDate?: string;
    quantityDeliveries: number;
  }[];
}

export interface VehicleTypes {
  totalRecords: number;
  page: number;
  rows: [
    {
      vehicleTypeId: string;
      vehicleType: string;
      payloadCapacity: string;
      packLoadWeight: string;
      costPerAssistant: string;
      driverCost: string;
      costPerKilometer: string;
      costPerTon: string;
      costPerCubicMeter: string;
      costPerOrder: string;
      created: string;
      updated: string;
    },
  ];
}

export interface Enterprise {
  name: string;
  cnpj: string;
  stateRegistration: string;
  chargeType: number;
  id: number;
}

export interface Distributor {
  name: string;
  cnpj: string;
  stateRegistration: string;
  zipCode: string;
  state: string;
  city: string;
  neighborhood: string;
  streetAddress: string;
  streetNumber: string;
  latitude: string;
  longitude: string;
  fee: number;
  feeType: string;
}

export interface Distributors {
  page: number;
  rows: {
    distributorId: string;
    name: string;
    cnpj: string;
    stateRegistration: string;
    latitude: string;
    longitude: string;
    fee: number;
    feeType: string;
    createdAt: string;
    updatedAt: string;
  }[];
  totalRecords: number;
}

export interface Driver {
  page: number;
  totalRecords: number;
  rows: {
    driverId: number;
    username: string;
    email: string;
    cpf: string;
    rg: number;
    phoneNumber: string;
    birthDate: string;
    status: string;
    driverLicense?: DriverLicense;
    createdAt: string;
    updatedAt: string;
  }[];
}

export interface Vehicle {
  plate: string;
  id: number;
  license_plate: string;
  year: string;
  model: string;
  load_capacity: number;
  weight: number;
  chest_width: number;
  chest_length: number;
  vehicle_type_id: number | string;
}

export interface AdminUsers {
  page: number;
  rows: {
    adminId: number;
    name: string;
    email: string;
    username: string;
  }[];
  totalRecords: number;
}

export interface Reprocessing {
  page: number;
  rows: Deliveries[];
  totalRecords: number;
}

export interface CartDetails {
  cartId: string;
  corporateName: string;
  totalWeight: string;
  createdAt: string;
  updatedAt: string;
  distance: string;
}

export interface AvailableCarts {
  page: number;
  rows: CartDetails[];
  totalRecords: number;
}

export interface User {
  id: number;
  name: string;
  email: string;
  username: string;
}

export interface DistributorUsers {
  page: number;

  rows: {
    distributorUserId: string;
    username: string;
    email: string;
    distributorUserType: string;
    createdAt: string;
    updatedAt: string;
  }[];
  totalRecords: number;
}

export interface Receipt {
  id: number;
  freight_code: number;
  social: string;
  driver: string;
  request: string;
}

export interface Company {
  id: number;
  name: string;
  cnpj: string;
  access: string;
}

export interface TablesState {
  dashboardAdmin: DashboardAdmin[];
  availableCarts: AvailableCarts;
  dashboard: Dashboard[];
  vehicleTypes: VehicleTypes;
  enterprises: Enterprise[];
  distributors: Distributors;
  distributor: Distributor;
  drivers: Driver;
  deliveries: Deliveries[];
  reprocessing: Reprocessing;
  vehicles: Vehicle[];
  adminUsers: AdminUsers;
  distributorUsers: DistributorUsers;
  users: User[];
  receipts: Receipt[];
  companies: Company[];
  currentDelivery: Deliveries;
  freights: Freights;
}
